import React from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

const DashboardPage = () => {
  return (
    <div className="h-screen flex flex-col">
      {/* Header */}
      <Header />

      {/* Layout with Sidebar + Content */}
      <div className="flex flex-1">
        {/* Sidebar */}
        <Sidebar />

      </div>
    </div>
  );
};

export default DashboardPage;
